import { useEffect, useRef, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { X } from "lucide-react";
import api, { vimg } from "@/lib/api";

const STATES = [
  "Texas", "California", "Florida", "New York", "Colorado", "Arizona",
  "Washington", "Illinois", "Georgia", "Nevada", "Ohio", "North Carolina",
];

export const LiveOrders = () => {
  const [products, setProducts] = useState([]);
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    if (!products.length) return undefined;
    let alive = true;
    const show = () => {
      if (!alive) return;
      const p = products[Math.floor(Math.random() * products.length)];
      const qty = Math.random() < 0.7 ? 1 : 2;
      const subtotal = p.price * qty;
      setToast({
        key: Date.now(),
        name: p.name,
        size: p.size,
        img: p.image_url,
        amount: (subtotal + (subtotal >= 300 ? 0 : 25)).toFixed(2),
        state: STATES[Math.floor(Math.random() * STATES.length)],
        mins: 1 + Math.floor(Math.random() * 9),
      });
      timer.current = setTimeout(() => {
        setToast(null);
        timer.current = setTimeout(show, 12000 + Math.random() * 14000);
      }, 6500);
    };
    timer.current = setTimeout(show, 8000);
    return () => {
      alive = false;
      clearTimeout(timer.current);
    };
  }, [products]);

  return (
    <AnimatePresence>
      {toast && (
        <motion.div
          key={toast.key}
          initial={{ opacity: 0, y: 24, x: -12 }}
          animate={{ opacity: 1, y: 0, x: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
          data-testid="live-order-toast"
          className="fixed bottom-5 left-5 z-[60] w-[calc(100%-2.5rem)] max-w-xs bg-white border border-[#E4E4E7] shadow-[0_20px_60px_rgba(9,9,11,0.15)] p-3.5"
        >
          <button
            onClick={() => setToast(null)}
            data-testid="live-order-dismiss"
            className="absolute top-2.5 right-2.5 p-1 text-[#A1A1AA] hover:text-[#09090B] transition-colors"
          >
            <X className="w-3.5 h-3.5" />
          </button>
          <div className="flex items-center gap-1.5 mb-2.5">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#6D28D9] opacity-60" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#6D28D9]" />
            </span>
            <span className="font-mono-clinical text-[9px] tracking-[0.25em] uppercase text-[#6D28D9]">Live order</span>
            <span className="font-mono-clinical text-[9px] text-[#A1A1AA] ml-auto pr-4">{toast.mins} min ago</span>
          </div>
          <div className="flex items-center gap-3">
            {toast.img && (
              <img src={vimg(toast.img)} alt="" className="w-11 h-11 object-cover border border-[#E4E4E7] shrink-0" />
            )}
            <div className="min-w-0">
              <p className="text-xs text-[#52525B] leading-snug">
                A researcher in <span className="font-bold text-[#09090B]">{toast.state}</span> ordered
              </p>
              <p className="text-xs font-bold text-[#09090B] truncate" data-testid="live-order-product">
                {toast.name} {toast.size}
              </p>
              <p className="font-mono-clinical text-[11px] text-[#6D28D9] font-bold" data-testid="live-order-amount">
                ${toast.amount}
              </p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
